import { render } from "./NotificationsSettings.vue?vue&type=template&id=577a2b79&ts=true"
import script from "./NotificationsSettings.vue?vue&type=script&lang=ts"
export * from "./NotificationsSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__